import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import { VNode } from 'vue'
import { ProductTypeUpdateDTO } from '@/service-proxies/app-v2/product.service-proxies'

@Component
export default class EditForm extends Vue {
  @Prop() record: ProductTypeUpdateDTO
  @Ref() readonly dForm: any
  schema = {}

  @Watch('record', { immediate: true })
  onRecordChange(val: ProductTypeUpdateDTO) {
    this.schema = {
      properties: {
        name: {
          title: this.$t('page_docdirectory_name'),
          maxLength: 32,
          ui: {
            placeholder: this.$t('page_business_data_product_type_name_tip')
          },
          default: val.name
        },
        description: {
          title: this.$t('page_business_data_description'),
          default: val.description,
          maxLength: 255,
          ui: {
            widget: 'textarea',
            placeholder: this.$t('page_business_data_product_type_description_tip')
          }
        },
        status: {
          title: this.$t('page_resource_pool_status'),
          default: !!(val.status === 2),
          ui: {
            widget: 'switch'
          }
        }
      },
      required: ['name']
    }
  }

  beforeUpdate() {
  }

  render(): VNode {
    return <d-form schema={this.schema} ref="dForm" />
  }
}
